import founderIcon from '../../../assets/images/founder-icon.svg';

export default function FounderMembers({ name, imageUrl, title, linkTree, bio}) {
    return (
        <div className="team-single w-full md:w-1/3">
            <div>
                <img src={imageUrl} className="headshot" alt={name}></img>
            </div>
            <div className="flex justify-between items-start mb-5">
                <div>
                    <p className="lt-white name">{name}</p>
                    <p className="title text-grey">{title}</p>
                </div>
                <div>
                    <a href={linkTree} target="_blank">
                        <img src={founderIcon} alt="Linktree Icon"></img>
                    </a>
                </div>
            </div>
            <div className="bio">
                <p className="text-grey">{bio}</p>
            </div>
        </div>
    )
}